import { lazy } from "react";

const Login = lazy(() => import("../pages/Login"));
const ForgetPassword = lazy(() => import("../pages/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/ResetPassword"));
const CreateStore = lazy(() => import("../pages/CreateStore"));
const HomePage = lazy(() => import("../pages/HomePage"));

const routes = [
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/forgot-password",
    component: ForgetPassword,
  },
  {
    path: "/reset-password/:storeId/:storeAdminId/:token",
    component: ResetPassword,
  },
  {
    path: "/create-store",
    component: CreateStore,
  },
  {
    path: "/",
    component: HomePage,
  },
];

export const routesArray = [
  "/login",
  "/forgot-password",
  "/reset-password/:token",
  "/create-store",
  "/edit-store",
  "/",
];

export default routes;
